import React, { useContext, useState } from 'react'
import { css, Global } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { ApprovedStatusType } from '@/models/reservation-approved-status'
import { Popover } from 'antd'
import { useErrorHandler } from '@/hooks/use-error-handler'
import { LoaderContextCreator } from '@/contexts/loader'
import { updateGuestRoomAssignStatus } from '@/apis/aipass'
import { ApprovedStatusButton } from '../approved-status-button'

type Props = {
  room: { reservationId: string; guestRoomAssignId: string; assignStatus: ApprovedStatusType }
  onChange: () => Promise<void>
}
export const RoomAssignStatusSelect: React.FC<Props> = props => {
  const { t } = useTranslation()
  const { setIsLoading } = useContext(LoaderContextCreator())
  const { errorHandler } = useErrorHandler()

  const [openChangeApprovedStatusPopup, setOpenChangeApprovedStatusPopup] = useState(false)

  const onChangeApprovedStatus = async (guestRoomAssignId: string, status: ApprovedStatusType) => {
    try {
      setIsLoading(true)
      await updateGuestRoomAssignStatus({
        reservationId: props.room.reservationId,
        guestRoomAssignIds: [guestRoomAssignId],
        status,
      })
      await props.onChange()
    } catch (e) {
      errorHandler(e)
    } finally {
      setIsLoading(false)
    }
  }

  const changeApprovedStatusPopup = () => (
    <ul>
      {[ApprovedStatusType.Checkin, ApprovedStatusType.Stay, ApprovedStatusType.Checkout].map((status, i) =>
        props.room.assignStatus === status ? (
          <></>
        ) : (
          <li
            key={i}
            css={dropDownContentStyle}
            onClick={e => {
              onChangeApprovedStatus(props.room.guestRoomAssignId, status)
              setOpenChangeApprovedStatusPopup(false)
            }}
          >
            <p css={dropDownTitleStyle}>{StatusText[status]}</p>
          </li>
        ),
      )}
    </ul>
  )

  const StatusText = {
    [ApprovedStatusType.Reservation]: t('Reserve'),
    [ApprovedStatusType.Checkin]: t('Checkin'),
    [ApprovedStatusType.Stay]: t('During your stay'),
    [ApprovedStatusType.Checkout]: t('Checkout'),
  }

  return (
    <>
      <Global
        styles={css({
          '.ant-popover-inner-content': { padding: 'unset' },
          '.ant-popover-placement-bottomRight': { paddingTop: 0 },
          '.ant-popover-arrow': { display: 'none' },
        })}
      />
      <Popover
        placement="bottomRight"
        trigger="click"
        content={changeApprovedStatusPopup()}
        visible={openChangeApprovedStatusPopup}
        onVisibleChange={visible => {
          setOpenChangeApprovedStatusPopup(visible)
        }}
      >
        <ApprovedStatusButton currentStatus={props.room.assignStatus} />
      </Popover>
    </>
  )
}

const dropDownContentStyle = css({
  display: 'flex',
  height: 34,
  listStyle: 'none',
  alignItems: 'center',
  padding: '0 16px',
  cursor: 'pointer',
  '&:hover': { background: '#f2f2f2' },
})

const dropDownTitleStyle = css({
  fontSize: 14,
  fontWeight: 'normal',
  color: '#272727',
})
